import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {CreditCardFee} from '../../graphql/payments.datatypes';

interface CreditCardFeeData {
    globalCreditCardFee: CreditCardFee;
}

export const gqlCreditCardFee = `
    id,
    fee,
    type,
    type_id
`;

export const GET_GLOBAL_CREDIT_CARD_FEE_QUERY = gql`
    query globalCreditCardFee{
        globalCreditCardFee{
            ${gqlCreditCardFee}
        }
    }
`;

export const getGlobalCreditCardFee = () => {
    return useQuery<CreditCardFeeData>(GET_GLOBAL_CREDIT_CARD_FEE_QUERY);
};

export default getGlobalCreditCardFee;
